var initialState = {
    byId: {},
    allIds: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.inavailabilityHour) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.inavailabilityHour
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
}
